import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { InformationRow, type InformationRowItem } from './InformationRow';

export type DefinitionListItem = readonly [label: ReactNode, value: ReactNode];

export type DefinitionListProps = {
  items: readonly (DefinitionListItem | InformationRowItem)[];
  testId?: string;
};

export function DefinitionList({ items, testId }: DefinitionListProps) {
  return <Box component="dl" data-testid={testId} sx={{ m: 0, display: 'flex', flexDirection: 'column', gap: `${designTokens.layout.informationRowGap}px` }}>
    {items.map((item, index) => {
      const row: InformationRowItem = 'label' in item ? item : { label: item[0], value: item[1] };
      return <InformationRow key={row.id ?? index} {...row} testId={testId && row.id ? `${testId}-${row.id}` : undefined} />;
    })}
  </Box>;
}
